<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form :rules="rules" ref="form" label-width="150px" :model="dioForm">
            <el-form-item :label="$t('param.type')" prop="type">
                <span>{{ typeText }}</span>
            </el-form-item>
            <el-form-item :label="$t('param.name')" prop="name">
                <el-input v-model.trim="dioForm.name" style="width: 250px" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('param.code')" prop="code">
                <el-input v-model.trim="dioForm.code" style="width: 250px" :placeholder="$t('public.please_enter')"
                    v-if="optareStatus === 'add'" />
                <span v-else>{{ dioForm.code }}</span>
            </el-form-item>
            <el-form-item :label="$t('param.content')" prop="content">
                <el-input v-model.trim="dioForm.content" style="width: 400px"
                    type="textarea" :rows="3" maxlength="250" show-word-limit
                    :placeholder="$t('public.please_enter')" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_apply') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { paramContentAddR, paramContentUpdateR } from '@/api/modules/params.js'
export default {
    props: {
        formRow: {
            type: Object,
            default: () => { }
        },
        isShow: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        optareStatus: {
            type: String,
            default: ""
        },
        typeText: {
            type: String,
            default: ''
        },
        typeId: {
            type: Number,
        }
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        },
        rules() {
            return {
                name: [{ required: true, message: this.$t('validate.param_name_required'), trigger: 'blur' },
                {
                    max: 50,
                    trigger: 'blur',
                    message: this.$t('validate.len_50')
                }
                ],
                content: [{ required: true, message: this.$t('validate.param_content_required'), trigger: 'blur' },
                {
                    max: 250,
                    trigger: 'blur',
                    message: this.$t('validate.len_250')
                }
                ],
                code: [{ required: true, message: this.$t('validate.param_code_required'), trigger: 'blur' },
                {
                    max: 30,
                    trigger: 'blur',
                    message: this.$t('validate.len_30')
                },
                {
                    validator: this.$fromRules.FormValidate.Form().ParamCode,
                    trigger: 'blur',
                },
                ],
            }
        }
    },
    watch: {
        formRow(newVal) {
            this.dioForm = { ...newVal }
        }
    },
    data() {
        return {
            dioForm: {
                typeId: "",
                name: "",
                code: "",
                content: ""
            }
        }
    },
    methods: {
        clearValidate() {
            this.dioForm = {
                typeId: "",
                name: "",
                code: "",
                content: ""
            }
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate()
            }
            catch (error) {
                return false
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return
            let httpUrl = paramContentAddR
            if (this.optareStatus === 'edit') {
                httpUrl = paramContentUpdateR
            }
            let param = { ...this.dioForm, typeId: this.typeId }
            httpUrl(param).then(({ state, result }) => {
                if (result === 200) {
                    this.$message.success(this.$t('param.code_200'));
                    this.isShowDialog = false;
                    this.$parent.getList();
                } else if (result === 400) {
                    this.$message.error(this.$t("param.code_400"))
                }
                else if (result === 408) {
                    this.$message.error(this.$t('param.code_408'))
                } else if (result === 409) {
                    this.$message.error(this.$t('param.code_409'))
                }
                else {
                    this.$message.error(this.$t('public.system_error'))
                }
            })
        },
    }
}
</script>

<style>

</style>